module.exports = __webpack_public_path__ + "img/error.cbe098c6.png";